import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import LoadingAnimation from '../../components/LoadingAnimation';
import useInterviewContext from '../../Context/mainContext';
import useToaster from '../../utils/Toaster';
import { useNavigate } from 'react-router-dom';
import TIRONEM_LOGO from '../../assets/TIRONEM_LOGO.png';
// import AuthBackgroundImage from '../../assets/BackGroundImg.png';
// import bg_top from '../../assets/bg_top.png';
// import bg_bottom from '../../assets/bg_bottom.png';

const CampaignInterviewLinkPage = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isValid, setIsValid] = useState(false);
  const [countdown, setCountdown] = useState(5);
  let interviewState: any = useInterviewContext();
  const [, sendNotification] = useToaster();
  const navigate = useNavigate();
  const base_url = window.location.origin;

  useEffect(() => {
    if (id) {
      const tokenId = localStorage.getItem('token');
      if (tokenId) {
        localStorage.clear();
      }

      interviewState.setCandidateLinkId(id);
      // let candidate_link = `https://thankful-pond-0c6b13600.2.azurestaticapps.net/interview/interview/campaign/${id}`;

      // let candidate_link = `https://interview.tironem.ai/interview/${id}`;
      let candidate_link = `${base_url}/interview/campaign/${id}`;
      // localStorage.setItem('candidate_link', candidate_link);
      sessionStorage.setItem('candidate_link', candidate_link);
      navigate('/signup');
    }
  }, [id]);

  useEffect(() => {
    if (countdown > 0) {
      setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    // else {
    //   interviewState.setTimerOff(true);
    // }
  }, [countdown]);

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          height: '100vh',
          width: '100vw',
          minHeight: '750px',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'white',
        }}
      >
        {/* <Box
          sx={{
            background: 'rgba(255, 255, 255, 0.3)',
            position: 'relative',
            height: '90%',
            width: '92%',
            borderRadius: '20px',
            border: '3px solid #FFFFFF',
            backdropFilter: 'blur(40px)',
          }}
        >
          <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
            <img src={bg_top} />
          </Box>
          <Box sx={{ position: 'absolute', bottom: '0', left: '0' }}>
            <img src={bg_bottom} />
          </Box> */}
        {/* <img
          src={AuthBackgroundImage}
          alt='AuthBackground_Image'
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
          }}
        /> */}
        {/* header */}
        <div
          style={{
            marginTop: '65px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <img
            src={TIRONEM_LOGO}
            alt='TIRONEM_logo'
            style={{
              width: '216px',
              height: '49px',
            }}
          />
        </div>{' '}
        <Box></Box>
        {!isLoading && (
          <Box
            sx={{
              height: '72vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Box>
              <LoadingAnimation />
            </Box>
            {isValid && (
              <>
                <Typography
                  sx={{
                    fontSize: '1.4rem',
                    fontWeight: '400',
                    marginTop: '10px',
                  }}
                >
                  Interview Link is either expired or not valid!
                </Typography>
                <Typography
                  sx={{
                    fontSize: '1.4rem',
                    fontWeight: '400',
                    marginTop: '10px',
                  }}
                >
                  You will be redirect to the login page in {countdown} seconds
                </Typography>
              </>
            )}
          </Box>
        )}
        {/* </Box> */}
      </Box>
    </>
  );
};
export default CampaignInterviewLinkPage;
